import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // ✅ Add this
import './index.css';
import App from './App';

const path = window.location.pathname;

const skipReactOn = [
  '/checkout',
  '/cart',
  '/checkout/order-pay',
  '/checkout/order-received',
];

if (!skipReactOn.some(prefix => path.startsWith(prefix))) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter> {/* ✅ Wrap App in Router */}
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
